import { type ComponentType, type FC } from 'react';
import './react-pure-modal.min.css';
import ConfigDrawer from './ConfigDrawer';

export interface SidebarProps {
  title: string;
  onSave?: React.ReactEventHandler;
  onCancel?: () => void;
  isOpen: boolean;
  withOpenButton: boolean;
  onClickOpenButton?: React.ReactEventHandler;
}

/**
 * To display content on a right sidebar.
 */
function RightSideBarify<P extends object>(
  Component: ComponentType<P>
): FC<P & SidebarProps> {
  const WrappedComponent: FC<P & SidebarProps> = (props) => {
    const {
      title,
      onSave: _onSave,
      onCancel,
      isOpen,
      withOpenButton: _withOpenButton,
      onClickOpenButton: _onClickOpenButton,
      ref: _ref,
      ...rest
    } = props as P & SidebarProps & { ref?: unknown };

    // Never forward ref or sidebar props to the wrapped component: spreading a
    // frozen ref object causes "can't define property current" at runtime.
    const componentProps = rest as unknown as P;

    if (!isOpen) {
      return null;
    }

    return (
      <ConfigDrawer
        open={isOpen}
        onClose={() => onCancel?.()}
        title={title || 'Configuration'}
      >
        <Component {...componentProps} />
      </ConfigDrawer>
    );
  };

  WrappedComponent.displayName = `RightSideBarify(${
    Component.displayName ?? Component.name ?? 'Component'
  })`;

  return WrappedComponent;
}

export default RightSideBarify;
